import axios from 'axios';
import  React, {use, useState} from 'react';
import { useNavigate, useParams } from "react-router-dom";
import Cookies from 'js-cookie';


import '../pages/styles/estandar/FormStyle.css';
import '../pages/styles/estandar/ButtonStyles.css';

import './styles/CreateUserForm.css';
import { CgWebcam } from 'react-icons/cg';
import MensajeError from './MensajeError';
import MensajeAlerta from './MensajeAlerta';
import { useConfig } from '../contexts/ConfigContext';


//A
const CreateUserForm = () =>{
    const [nombre, setNombre] = useState("");
    const [correo, setCorreo] = useState("");
    const [contraseña, setContraseña] = useState("");
    const [confirmarContraseña, setConfirmarContraseña] = useState("");
    const [ROL, setROL] = useState(0);
    const config = useConfig();


    //ERRORES
    const [nombreError, setNombreError] = useState("");
    const [correoError, setCorreoError] = useState("");
    const [contrasenaError, setContrasenaError] = useState("");
    const [confContrasenaErro, setConfContrasenaErro] = useState("");
    const[rolError, setRolError] = useState("");

    //Error generico
    const [showError, setShowError] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    //Alerta mensaje
    const [showAlertMensaje, setShowAlertMensaje] = useState(false);
    const [AlertMensaje, setAlertMensaje] = useState("");

    const navigate = useNavigate();

    const limpiarErrores = () =>{
        setNombreError('');
        setCorreoError('');
        setContrasenaError('');
        setConfContrasenaErro('');
        setRolError('');
    }

    const setearErrores = (jsonErrores) =>{
        for(const field in jsonErrores){
            if(jsonErrores.hasOwnProperty(field)){
                const errorMessage = jsonErrores[field][0];
                switch(field){
                    case 'nombre':
                        setNombreError(errorMessage);
                        break;
                    case 'correo':
                        setCorreoError(errorMessage);
                        break;
                    case 'contrasena':
                        setContrasenaError(errorMessage);
                        break;
                    case 'confirmarContrasena':
                        setConfContrasenaErro(errorMessage);
                        break;
                    case 'ROL':
                        setRolError(errorMessage);
                        break;
                    case 'existente':
                        setErrorMessage(errorMessage);
                        setShowError(true);
                    default:
                        console.warn('Error campo desconocido');

                }
            }
        }
    }

    const crearUsuario = async(e) =>{
        const API_URL =`${config.API_URL}/api/usuario/crear/`;

        //Configuramos axios para que añada al header el respectivo token
        axios.interceptors.request.use(
        (config) => {
            const token = Cookies.get('usr');
            if (token) {
            config.headers['Authorization'] = `Bearer ${token}`;
            }
            return config;
        },
        (error) => {
            console.error(error)
        }
        );

        e.preventDefault();

        const formularioUsuario = {
            nombre: nombre,
            correo: correo,
            contrasena: contraseña,
            confirmarContrasena: confirmarContraseña,
            rol: ROL
        }

        limpiarErrores();

        try{
            const response = await axios.post(API_URL, formularioUsuario, {Authorization: true});

            if(response.status >= 200 && response.status < 300){
                setAlertMensaje(response.data.mensaje);
                setShowAlertMensaje(true);
            }else{
                setErrorMessage(`Error inesperado: ${response.status} ${response.statusText}`);
                 setShowError(true);
            }
        }catch(error){
            if(axios.isAxiosError(error)){
                if(error.response){
                    var jsonRespuesta = error.response.data;
                    console.log(jsonRespuesta);
                    setearErrores(jsonRespuesta["errors"]);

                }else if(error.request){
                    console.error('No se recibió respuesta del backend:', error.request);
                    setErrorMessage('No se recibió respuesta del backend:' + error.request);
                    setShowError(true);
                }else{
                     console.error('Error al configurar la solicitud:', error.message);
                    setErrorMessage('Error al configurar la solicitud:'+ error.message);
                    setShowError(true);
                }
            }else{
                 console.error('Error desconocido:', error);
                setErrorMessage(error);
                setShowError(true);
            }
        }
        
    }

    const handleCloseError = () => {
        setShowError(false); // Oculta el mensaje de error cuando el usuario hace clic en "Aceptar"
        setErrorMessage(''); // Opcional: limpia el mensaje de error
    };

    const handleRedireccionarLista = () =>{
        window.location.reload(); 
    }

    return(
        <div className='CreateUserForm'>
            <MensajeError mensaje={errorMessage} show={showError} onClose={handleCloseError}/>
            <MensajeAlerta mensaje={AlertMensaje} show={showAlertMensaje} onClose={handleRedireccionarLista}/>

            <form className='FormContainer' onSubmit={crearUsuario}>
                <label htmlFor='nombre' className='labelF'>Nombre: </label>
                <input type='text' id='nombre' name='nombre'className='inputF' value={nombre} onChange={(e) => setNombre(e.target.value)} maxLength="300"/>
                {nombreError && <p className='errorMsg'>*{nombreError}</p>}

                <label htmlFor='correo' className='labelF'>Correo:</label>
                <input type='text' id='correo' name='correo' className='inputF' value={correo} onChange={(e) => setCorreo(e.target.value)} maxLength="200"/>
                {correoError && <p className='errorMsg'>*{correoError}</p>}

                <label htmlFor='contrasena' className='labelF'>Contraseña:</label>
                <input type='password' id='contrasena' name='contrasena' className='inputF' value={contraseña} onChange={(e) => setContraseña(e.target.value)} maxLength="50"/>
                {contrasenaError && <p className='errorMsg'>*{contrasenaError}</p>}

                <label htmlFor='confirmarContra' className='labelF'>Confirmar contraseña:</label>
                <input type='password' id='confirmarContra' name='confirmarContra' className='inputF' value={confirmarContraseña} onChange={(e) => setConfirmarContraseña(e.target.value)} maxLength="50"/>
                {confContrasenaErro && <p className='errorMsg'>*{confContrasenaErro}</p>}

                <label htmlFor='rol' className='labelF'>ROL:</label>
                <select value={ROL} className='inputF' onChange={(e) => setROL(e.target.value)}>
                    <option value="100"defaultChecked>Selecciona un rol</option>
                    <option value="1">Administrador</option>
                    <option value="2">Usuario</option>
                </select>
                {rolError && <p className='errorMsg'>*{rolError}</p>}

                <button className='buttonStandartGreen' id='guardarUsuario' type='submit'>Guardar</button>
            </form>
        </div>
    );

}

export default CreateUserForm;